import { apiClient } from "./client";

export type ApiInfo = {
  name: string;
  version: string;
  env: string;
  locales: string[];
  features: Record<string, boolean>;
};

export async function fetchApiInfo(): Promise<ApiInfo> {
  const { data } = await apiClient.get<ApiInfo>("/api/v1/info");
  return data;
}
